<template>
  <div>
    <b-table
      sticky-header
      :per-page="perPage"
      :current-page="currentPage"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      responsive
      :busy="false"
      tbody-tr-class="cursor-pointer"
      @row-clicked="onRowClicked"
    >

    </b-table>

  </div>
</template>

<script>
import numeral from 'numeral'
import moment from 'moment'
// import FamiliareModal from '@/components/FamiliareModal'

export default {
  name: 'AccessoRapportiUtenzaBUTable',
  // components: {
  //   FamiliareModal
  // },
  props: {
    items: { type: Array, required: true }
  },

  data () {
    return {
      currentPage: 1,
      perPage: 0,
      totalRows: 0,
      fields: [
        { key: 'codiceBu', label: 'Rapporto utenza' },
        { key: 'codiceRu', label: 'Unità immobiliare' },
        { key: 'indirizzo', label: 'Indirizzo' },
        { key: 'indirizzoExt', label: 'Interno scala piano' }
      ]
    }
  },

  computed: {
    numeral () {
      return numeral
    },
    moment () {
      return moment
    },
    rows () {
      return this.items
    }
  },

  methods: {
    async onRowClicked (row) {
      // console.log('Accedi a una richiesta di icarico', row)
      // Devo mettere una emait per il metodo da richiamare

      this.$emit('RUSelected', row)
    }

  }
}
</script>

<style lang="stylus" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
